// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e6mnC","placeholdersHeader":"styles_placeholdersHeader__2625E","editorStyle":"styles_editorStyle__2WDOe","placeholdersBox":"styles_placeholdersBox__2kV5R"};